<template>
    <div class="wbk-categories" v-if="actionFieldData">
        <div class="wbk-categories__image" v-if="false">
            <transition name="fade">
                <img :src="mainSetup.icon.url" :alt="mainSetup.icon.alt" v-show="activeCategory === 0">
            </transition>
            <transition v-for="category in actionFieldData" name="fade">
                <img :src="category.image.url" :alt="category.image.alt" v-show="activeCategory === category.id">
            </transition>
        </div>
        <ul :class="['wbk-categories__list', `wbk-categories__list--${activeActionFieldSlug}`]">
            <li :class="['wbk-categories__list--default', {'wbk-categories--active-category': activeCategory === 0}]">
                <span @click="setActiveCategory( { id: 0, name: 'Alle', slug: '' } )">Alle</span>
            </li>
            <li v-for="category in actionFieldData" :class="[`wbk-categories__list--${category.slug}`, {'wbk-categories--active-category': activeCategory === category.id}]">
                <span @click="setActiveCategory( category )">{{ category.name }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'WBKCategories',
    data() {
        return {
            activeCategory: 0,
        }
    },
    computed: {
        ...mapGetters( [
            'actionFieldData',
            'actionFieldById',
            'mainSetup'
        ] ),
        activeActionFieldSlug() {
            const activeActionField = this.actionFieldById( this.activeCategory )

            return activeActionField ? activeActionField.slug : 'default'
        }
    },
    methods: {
        setActiveCategory( category ) {
            this.activeCategory = category.id
            this.$store.commit( 'setActionFieldFilter', [category] )
        }
    },
}
</script>

<style lang="scss">
.wbk-categories {
    display: flex;

    &__image {
        width: 50%;
        position: relative;

        img {
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    &__list {
        list-style: none;
        padding: 0;
        margin: 0;
        width: 50%;

        span {
            cursor: pointer;
        }
    }

    &--active-category {
        font-weight: bold;
    }
}
</style>
